"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.named = named;
const incrementPendingClassMetadataCount_1 = require("../actions/incrementPendingClassMetadataCount");
const updateMetadataName_1 = require("../actions/updateMetadataName");
const buildMaybeClassElementMetadataFromMaybeClassElementMetadata_1 = require("../calculations/buildMaybeClassElementMetadataFromMaybeClassElementMetadata");
const injectBase_1 = require("./injectBase");
function named(name) {
    const updateMetadata = (0, buildMaybeClassElementMetadataFromMaybeClassElementMetadata_1.buildMaybeClassElementMetadataFromMaybeClassElementMetadata)((0, updateMetadataName_1.updateMetadataName)(name));
    return (0, injectBase_1.injectBase)(updateMetadata, incrementPendingClassMetadataCount_1.incrementPendingClassMetadataCount);
}
//# sourceMappingURL=named.js.map